export default {"src":"/_next/static/media/cross.df08df97.svg","height":20,"width":20};